import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import orderBy from 'lodash/orderBy';
import { ErrandPanelApiContext } from '../ErrandPanel/ErrandPanelApi';
import { ErrandPanel } from '../ErrandPanel/ErrandPanel';
const reducers = {
    onBeforeExecuteErrand: (getParams)=>async (prev, h)=>{
            return await prev && await h.handler(...getParams());
        },
    onAfterExecuteErrand: (getParams)=>async (prev, h)=>{
            await prev;
            await h.handler(...getParams());
        },
    onEvaluateButtonState: (getParams)=>(prev, h)=>{
            if (prev.state === 'Hidden') {
                return prev;
            }
            const cur = h.handler(...getParams());
            if (!cur) {
                return prev;
            }
            if (cur.state === 'Hidden') {
                return cur;
            }
            return prev.state === 'Disabled' ? prev : cur;
        }
};
// todo: typade rowmodels
export const SimplifiedErrand = (props)=>{
    const { children, validationPredicate, reportingPositions, topPositions, options, validate, unsubscribeRef, row } = props;
    const [buttonOptions, setButtonOptions] = useState(options);
    const [RootComponent, setRootComponent] = useState(null);
    const [errandComment, setErrandComment] = useState('');
    const [originalComment, setOriginalComment] = useState('');
    useEffect(()=>{
        setErrandComment(originalComment);
    }, [
        originalComment
    ]);
    const errandPanelApi = useMemo(()=>{
        const handlers = {
            onBeforeExecuteErrand: [],
            onAfterExecuteErrand: [],
            onEvaluateButtonState: []
        };
        const getEventRegistrator = function(eventName) {
            return {
                on: (fn, opts = {
                    sortOrder: 0
                })=>handlers[eventName].push({
                        handler: fn,
                        options: opts
                    }),
                off: (fn)=>{
                    handlers[eventName] = handlers[eventName].filter((x)=>x.handler !== fn);
                },
                trigger: (getParams, defaultValue)=>{
                    const orderedHandlers = orderBy(handlers[eventName], (x)=>x.options.sortOrder);
                    const reducer = reducers[eventName](getParams);
                    return orderedHandlers.reduce(reducer, defaultValue);
                }
            };
        };
        return {
            setRootComponent: (comp)=>{
                setRootComponent(comp);
                unsubscribeRef.current?.();
            },
            setButtonOptions,
            events: {
                onBeforeExecuteErrand: getEventRegistrator('onBeforeExecuteErrand'),
                onAfterExecuteErrand: getEventRegistrator('onAfterExecuteErrand'),
                onEvaluateButtonState: getEventRegistrator('onEvaluateButtonState')
            },
            setErrandComment: (fn)=>setErrandComment(fn(originalComment ?? ''))
        };
    }, [
        originalComment,
        unsubscribeRef
    ]);
    if (RootComponent) {
        return RootComponent;
    }
    return /*#__PURE__*/ _jsxs(ErrandPanelApiContext.Provider, {
        value: errandPanelApi,
        children: [
            /*#__PURE__*/ _jsx(ErrandPanel, {
                reportingPositions: reportingPositions,
                topPositions: topPositions,
                options: buttonOptions,
                errandComment: errandComment,
                setOriginalComment: setOriginalComment,
                validate: validate,
                validationPredicate: validationPredicate,
                row: row
            }),
            children
        ]
    });
};
